import styled from 'styled-components';

import { device } from '@/styles/helpers';

interface IScJackpotCardProps {
  bgImage: string;
}

export const ScJackpotCard = styled.div<IScJackpotCardProps>`
  border-radius: 20px;
  background:
    url(${({ bgImage }) => bgImage}),
    linear-gradient(341deg, #ab1d63 -10.86%, #f06723 95.6%);
  background-size: cover;
  background-position: 100% 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 16px;

  & .odometer.odometer-auto-theme,
  .odometer.odometer-theme-default {
    font-family: 'Work Sans';
    font-size: 52px;
    font-weight: 900;
    line-height: 110%;
    font-variant-numeric: tabular-nums;

    @media (${device.mobile}) {
      font-size: 44px;
    }

    & .odometer-digit:nth-last-child(-n + 2) {
      font-size: 40px;
      letter-spacing: 1.2px;
    }
  }

  & > .decor {
    position: absolute;
    z-index: 1;

    &.left-top {
      top: -18px;
      left: -45px;
      transform: rotate(5deg);
      @media (${device.mobile}) {
        left: -35px;
      }
    }
    &.right-top {
      top: 30px;
      right: -35px;
      transform: rotate(-24deg);
      @media (${device.mobile}) {
        right: -25px;
      }
    }
    &.left-bottom {
      left: -35px;
      bottom: 9px;
      transform: rotate(-24deg);
      @media (${device.mobile}) {
        left: -15px;
      }
    }
    &.right-bottom {
      right: -40px;
      bottom: -44px;
      @media (${device.mobile}) {
        right: -30px;
        bottom: -30px;
        zoom: 0.8;
      }
    }
  }
  & > .content {
    display: grid;
    gap: 24px;

    & > .jackpot {
      font-weight: 700;

      & .title {
        font-size: 22px;
        line-height: 28px;
        letter-spacing: 0.44px;
        margin-bottom: 8px;
        text-transform: uppercase;
      }

      & .amount {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 52px;
        font-weight: 900;
        line-height: 110%;
        overflow: hidden;
        height: 57px;

        @media (${device.mobile}) {
          font-size: 44px;
          height: 48px;
        }
      }

      &.en-NZ {
        & .odometer.odometer-auto-theme,
        .odometer.odometer-theme-default {
          font-size: 46px;
          @media (${device.mobile}) {
            font-size: 40px;
          }

          & .odometer-digit:nth-last-child(-n + 2) {
            font-size: 34px;
          }
        }
        & .amount {
          font-size: 46px;
          height: 51px;
          overflow: hidden;
          @media (${device.mobile}) {
            font-size: 40px;
            height: 44px;
          }
        }
      }
    }

    & > .payments {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 12px;
      padding: 12px;
    }
  }
`;
